import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

/** Captura del MPXR de una incidencia (fuera del alta y la edición). */
@Component({
  selector: 'app-incident-mpxr-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>MPXR · {{ data.folio }}</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="full">
        <mat-label>MPXR</mat-label>
        <input matInput [(ngModel)]="value" maxlength="40" autocomplete="off" cdkFocusInitial
               (keydown.enter)="valid && save()">
        <mat-hint>Letras, números, guiones o diagonales. Déjalo vacío para quitarlo.</mat-hint>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" mat-dialog-close>Cancelar</button>
      <button mat-flat-button color="primary" type="button" [disabled]="!valid" (click)="save()">Guardar</button>
    </mat-dialog-actions>
  `,
  styles: [`.full { width: 100%; min-width: 280px; }`],
})
export class IncidentMpxrDialogComponent {
  readonly data = inject<{ folio: string; mpxr: string | null }>(MAT_DIALOG_DATA);
  private readonly ref = inject(MatDialogRef<IncidentMpxrDialogComponent>);
  value = this.data.mpxr ?? '';

  get valid(): boolean {
    const v = this.value.trim();
    return !v || /^[A-Za-z0-9 ._/-]{1,40}$/.test(v);
  }

  save(): void { this.ref.close(this.value.trim().toUpperCase()); }
}
